export default "__VITE_ASSET__BVpzJ8_D__"